export default "__VITE_ASSET__jwLB2YKx__"